import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { FilterSelect, FilterType } from "./header/FilterSelect";
import { BulkActions } from "./header/BulkActions";
import { Grid, List } from "lucide-react";

interface ScheduleHeaderProps {
  selectedInvoices: string[];
  onFilterChange: (filter: FilterType) => void;
  onBulkActionSelect: (action: string | null) => void;
  onDeleteClick: () => void;
  currentFilter: FilterType;
  onSelectAll: () => void;
  hasVisibleInvoices: boolean;
  viewType: "grid" | "list";
  onViewTypeChange: (viewType: "grid" | "list") => void;
}

export const ScheduleHeader = ({
  selectedInvoices,
  onFilterChange,
  onBulkActionSelect,
  onDeleteClick,
  currentFilter,
  onSelectAll,
  hasVisibleInvoices,
  viewType,
  onViewTypeChange,
}: ScheduleHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => onViewTypeChange(viewType === "grid" ? "list" : "grid")}
            className="mr-2 bg-white hover:bg-[#5CC2BB] hover:text-[#34375B] hover:border-transparent hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-[1px] hover:-translate-y-[1px] transition-all duration-200"
          >
            {viewType === "grid" ? <List className="h-4 w-4" /> : <Grid className="h-4 w-4" />}
          </Button>
          <Button
            variant="outline"
            onClick={onSelectAll}
            disabled={!hasVisibleInvoices}
            className="bg-white hover:bg-[#5CC2BB] hover:text-[#34375B] hover:border-transparent hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-[1px] hover:-translate-y-[1px] transition-all duration-200"
          >
            {selectedInvoices.length > 0 ? t("select_all.deselect_all") : t("select_all.select_all")}
          </Button>
        </div>
        <div className="flex items-center gap-4 w-full sm:w-auto">
          <FilterSelect
            currentFilter={currentFilter}
            onFilterChange={onFilterChange}
          />
          <BulkActions
            selectedInvoices={selectedInvoices}
            onBulkActionSelect={onBulkActionSelect}
            onDeleteClick={onDeleteClick}
          />
        </div>
      </div>
    </div>
  );
};